<mat-form-field [hidden]="frmGroup.get(this.configData.name)['hidden']" fxFlex="0 0 100%" appearance="outline" [formGroup]="frmGroup" color="accent">
  <mat-label>{{ configData.label }}</mat-label>
  <input matInput autocomplete="off" type="{{configData.type}}" [formControlName]="configData.name"
    [placeholder]="configData.placeHolder" [required]="configData.required" [matAutocomplete]="auto"
    (keyup)="fetchAutocompleteList($event)" (change)="requireMatch()" />
  
  <mat-hint *ngIf="noItemFound">
    <mat-error>
      {{noItemFoundError}}
    </mat-error>
  </mat-hint>
  
  <mat-error *ngIf="frmGroup.get(configData.name).errors">
    <mat-error *ngIf="frmGroup.get(configData.name).errors.required">
      {{requiredError}}
    </mat-error>
    <mat-error *ngIf="frmGroup.get(configData.name).errors.NoItemFound">
      {{noItemFoundError}}
    </mat-error>
    <mat-error *ngIf="frmGroup.get(configData.name).errors.selectFromList">
      {{selectFromListError}}
    </mat-error>
    <mat-error *ngIf="frmGroup.get(configData.name).errors.pattern && validationType === 'NoSpecialCharacter' ">  
        {{specialCharError}}
    </mat-error>
  </mat-error>
  
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option disabled style="cursor: not-allowed;" *ngIf="progressBar">
      <app-progress-spinner-v2></app-progress-spinner-v2>   
    </mat-option>   
    <mat-option class="autocomplete-item" *ngFor="let item of autocompleteList"
      (onSelectionChange)="selectedItem($event, item)" tabindex="0" [value]="getValue(item)">    

      <div fxLayout="row" fxLayoutAlign="center center">
        <div fxFlex="0 0 40px" *ngIf="autoCompleteMetaData.matIcon">
          <mat-icon color="accent">{{autoCompleteMetaData.matIcon}}</mat-icon>
        </div>
        <div fxFlex="calc(100%-40px)">
          <span class="item-autocomplete-header" *ngIf="autoCompleteMetaData.primaryText.length > 0">            
            {{item[autoCompleteMetaData.primaryText[0]]}} 
            <span *ngIf="item[autoCompleteMetaData.primaryText[1]]"> - </span>
            {{item[autoCompleteMetaData.primaryText[1]]}}
          </span>
          <br />
          <span class="item-autocomplete-detail" *ngIf="autoCompleteMetaData.secondaryText.length > 0">
            <span>
              {{item[autoCompleteMetaData.secondaryText[0]]}}
            </span>
            <span>
              <span>
                , {{item[autoCompleteMetaData.secondaryText[1]]}}
              </span>
            </span>
          </span>
        </div>
      </div>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>